import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-487fab7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card__header" }
const _hoisted_2 = { class: "card__subject" }
const _hoisted_3 = {
  key: 0,
  class: "card__badge product-card-badge product-card-badge_announcement"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "card__image-box" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "card__front" }
const _hoisted_8 = {
  class: "card__btn-public",
  type: "button"
}
const _hoisted_9 = {
  key: 1,
  class: "card__workbook"
}
const _hoisted_10 = { class: "card__buttons" }
const _hoisted_11 = { class: "card__title" }

import { computed } from 'vue';
import { ElTooltip } from 'element-plus';
import { LocationAsRelativeRaw } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import useExpirationDateText from '@/composition/useExpirationDateText';
import { names } from '@/constants/routes';
import { LabData } from '@/types/LabData';
import { ProductStateEnum } from '@/types/enums';
import dayjs from '@/utils/dayjs';
import { isLicenseSoonExpires } from '@/utils/license';
import { LicenseState } from '@/router/Laboratories/Laboratory/constants';

import LaunchProduct from '@/components/Card/LaunchProduct.vue';
import SourceImage from '@/components/Card/SourceImage.vue';
import IconWorkbook from '@/components/icons/NoteBook.vue';
import IconPencilLine from '@/components/icons/PencilLine.vue';
import IconPublishing from '@/components/icons/Publishing.vue';
import IconEyeSlash from '@/components/icons/EyeSlash.vue';
import IconTrashWithCheckMark from '@/components/icons/TrashWithCheckMark.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCard',
  props: {
    card: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const store = useStore();

const isPublication = computed(() => props.card.state === ProductStateEnum.Publication
  || props.card.state === ProductStateEnum.RePublication);
const isDraft = computed(() => props.card.state === ProductStateEnum.Draft);
const isMarkedForDeletion = computed(() => props.card.state === ProductStateEnum.MarkedForDeletion);
const isNotPublished = computed(
  () => !isDraft.value && !props.card.enabled && !isMarkedForDeletion.value
);
const isAnnouncement = computed(() => props.card.enabled_as_promo && !isMarkedForDeletion.value);

const isSuAccessRole = computed(() => store.getters.isSuAccessRole);

const hasEditBtn = computed(() => store.getters.isAdmin || store.getters.isModerator
    // eslint-disable-next-line vue/max-len
    || (store.getters.isMarketer && !isMarkedForDeletion.value && (isAnnouncement.value || !isDraft.value)));

const opacityClass = computed(() => {
  if (props.card.license_state || isAnnouncement.value) {
    return {};
  }

  return {
    'is-draft': isDraft.value || isMarkedForDeletion.value,
    'not-published': isPublication.value || isNotPublished.value,
  };
});

const isActive = computed<boolean>(
  () => dayjs().isBefore(dayjs(props.card.license_expiration_date))
);

const expirationDate = computed(() => {
  if (!props.card.license_expiration_date) {
    return '';
  }

  return new Date(props.card.license_expiration_date).getTime();
});

const isSoonExpires = computed(() => props.card.license_expiration_date
    && isLicenseSoonExpires(props.card.license_expiration_date, 48));

const expirationDateText = computed(() => {
  if (isOrganisation.value || !expirationDate.value || !props.card.active_for_user) {
    return '';
  }

  return useExpirationDateText({
    expirationDate: expirationDate.value,
    isActive: isActive.value,
    showTime: Boolean(isSoonExpires),
  });
});

const tooltipIconText = computed(() => {
  if (isAnnouncement.value) {
    return false;
  }
  if (isPublication.value) {
    return {
      text: t('publication'),
      icon: IconPublishing,
    };
  }
  if (isNotPublished.value) {
    return {
      text: t('notPublished'),
      icon: IconEyeSlash,
    };
  }
  if (isDraft.value) {
    return {
      text: t('draft'),
      icon: IconPencilLine,
    };
  }
  if (isMarkedForDeletion.value) {
    return {
      text: t('markedForDeletion'),
      icon: IconTrashWithCheckMark,
    };
  }
  return false;
});

const linkMore = computed<LocationAsRelativeRaw>(() => {
  if (!isAnnouncement.value) {
    return { name: names.laboratory, params: { id: props.card.id } };
  }
  return undefined;
});
const linkEditPage = computed<LocationAsRelativeRaw>(() => (
  { name: names.editProduct, params: { id: props.card.id } }
));

const licenseType = computed(() => {
  if (typeof props.card.license_state === 'boolean') {
    return false;
  }
  return props.card.license_state.replace('licenses.license_state_', '');
});

const isOrganisation = computed(() => props.card.license_state === LicenseState.Organization);

const licenseStateLabel = computed(() => {
  if (!licenseType.value) {
    return false;
  }
  return t(`labs.licenseState.${licenseType.value}`);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(linkMore.value ? 'router-link' : 'div'), {
    to: linkMore.value,
    class: _normalizeClass(['card', { hold: isAnnouncement.value }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.card.subsection.name), 1),
        (isAnnouncement.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('labs.soon')), 1))
          : _createCommentVNode("", true),
        (props.card.license_state && licenseStateLabel.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(ElTooltip), {
                class: "card__tooltip-time",
                effect: "light",
                content: expirationDateText.value,
                disabled: !expirationDateText.value,
                rawContent: "",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["card__subscribe", {
                'expire': isSoonExpires.value && !isOrganisation.value,
              }])
                  }, _toDisplayString(licenseStateLabel.value), 3)
                ]),
                _: 1
              }, 8, ["content", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("picture", {
          class: _normalizeClass(opacityClass.value)
        }, [
          _createVNode(SourceImage, { card: _ctx.card }, null, 8, ["card"]),
          _createElementVNode("img", {
            src: "/img/empty/card.png",
            alt: _ctx.card.name,
            class: "card__img",
            loading: "lazy"
          }, null, 8, _hoisted_6)
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          (isSuAccessRole.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (tooltipIconText.value)
                  ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                      key: 0,
                      effect: "light",
                      content: tooltipIconText.value.text,
                      rawContent: "",
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", _hoisted_8, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(tooltipIconText.value.icon)))
                        ])
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.card.has_workbook)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(IconWorkbook)
              ]))
            : _createCommentVNode("", true),
          (!isAnnouncement.value)
            ? (_openBlock(), _createBlock(LaunchProduct, {
                key: 2,
                card: _ctx.card,
                class: "card__play"
              }, null, 8, ["card"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (hasEditBtn.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "card__btn",
                  to: linkEditPage.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('universalEdit')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (!isAnnouncement.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "card__btn",
                  to: linkMore.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('more')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.card.name), 1)
    ]),
    _: 1
  }, 8, ["to", "class"]))
}
}

})